import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import qs from 'querystringify';
import Spinner from '../../../components/common/Spinner';
import PageLayout from '../../../components/common/PageLayout';
import { postIntegrationShopifyRetailer } from '../../../store/actions/integrations';
import { useLocation } from 'react-router-dom';

export default function IntegrationShopifyContainer(props) {
  const dispatch = useDispatch();
  const location = useLocation();
  const postedRef = useRef(false);

  useEffect(() => {
    if (!postedRef.current) {
      const queryParams = qs.parse(location.search);
      dispatch(postIntegrationShopifyRetailer(queryParams));
      postedRef.current = true;
    }
  }, [dispatch, location]);

  return (
    <PageLayout>
      <div style={{ marginTop: '3em', textAlign: 'center' }}>
        <h2>Connecting your Shopify Account...</h2>
        <Spinner size="large" />
      </div>
    </PageLayout>
  );
}
